
export default {
    set: function(modal) {
        this.modal = modal;
    },
    show: function(callback) {
        let self = this;
        $(this.modal.template).on('click', function(e) {
            if ($(e.target).hasClass('modal')) {
                self.modal.display = false;
                self.close();
            }
        }).css({display: 'block', overflow: 'auto'});
        if (!($('.modal-backdrop').length > 0)) {
            let $backdrop = $('<div class="modal-backdrop fade show"></div>');
            let $loading = $(
                '<div style="text-align: center; position: absolute; top: 50%; left: 50%">\n' +
                '   <h1 id="loading-text">\n' +
                '       <i class="fa fa-spinner fa-spin fa-2x"></i>\n' +
                '       <span class="f-s-16">\n' +
                '           Loading...\n' +
                '       </span>\n' +
                '   </h1>\n' +
                '</div>'
            );
            $('body').append($backdrop.append($loading));
        }
        if (callback) {
            callback();
        }
    },
    loaded: function() {
        $('#loading-text').hide();
    },
    close: function(callback) {
        this.modal.display = false;
        this.modal.data = {};
        $('.modal-backdrop').remove();
        if (callback) {
            callback();
        }
    },
}
